<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.degiskenler"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">


<!-- grouped attributes -->
<Accordion :multiple="true">
  <AccordionTab v-for="attributegroup in attributegroups" >
    <template #header>
      <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">{{getTheTranslation(attributegroup,"translation")}}</span>
          <Badge :value="attributegroup.customattributes.length" class="ml-auto" severity="info" />
      </span>
    </template>
    <template v-for="attribute in attributegroup.customattributes">
  <template v-if="attribute.supplierattributes.length">
  
  <CustomAttributeEditor :attribute="attribute"   @dataReneved="dataReneved" @showHistory="showHistory"/>

</template>
</template>




    </AccordionTab>
</Accordion>
<!-- grouped attributes -->

<!-- ungrouped attributes -->
<template v-for="attribute in attributes">
<template v-if="attribute.supplierattributes.length">  
<CustomAttributeEditor :attribute="attribute"   @dataReneved="dataReneved" @showHistory="showHistory" />
</template>
</template>
<!-- ungrouped attributes -->


</div>
</template>


<SupplierAttributeHistory ref="supplierattributehistory" />
</div>
</template>

<script>
import CustomAttributeEditor from "./CustomAttributeEditor"
import SupplierAttributeHistory from "./SupplierAttributeHistory"

export default {

  name: 'SupplierAttributes',

  data () {
    return {
    	attributes:[],
    	loading:true,
    	attributegroups:[],
     	ungroupedattributes:[],
    }
  },
  components:{CustomAttributeEditor,SupplierAttributeHistory},
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"degiskenler") 
  	this.getData()
  },
  methods:{
  	showHistory(supplierattribute_id)
  	{
  		console.log(this.$refs)
  		this.$refs.supplierattributehistory.showModal(supplierattribute_id)
  	},
  	async getData()
    {
        this.attributes = await this.generalApiGetWithoutLoader("supplier_attributes_without_groups/"+this.$route.params.id)
        this.attributegroups = await this.generalApiGetWithoutLoader("supplier_attributes_with_groups/"+this.$route.params.id)
        console.log(this.attributes)
        this.loading = await false
    },
    dataReneved()
    {
      this.getData()
    },

  },
}
</script>

<style lang="css" scoped>
</style>